export const BRAND = "DjiniousLab";

export const NAV_LINKS: { label: string; to: string }[] = [
  { label: "Product", to: "/features" },
  { label: "Demos", to: "/demos" },
  { label: "Use Cases", to: "/use-cases" },
  { label: "AI & Automation", to: "/ai" },
  { label: "Enterprise", to: "/enterprise" },
];

export const FOOTER_TAGLINE =
  "One engineering notebook for model-based design — model, simulate, and generate on a living digital replica.";

/** Where the demo form POSTs. Override via VITE_DEMO_ENDPOINT to swap delivery later. */
export const DEMO_ENDPOINT = (import.meta.env.VITE_DEMO_ENDPOINT as string | undefined) ?? "/api/demo-request";
